export default "__VITE_ASSET__CYoKUqMG__"